import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

// Material-UI
import MuiDrawer from '@material-ui/core/Drawer';
import MuiList from '@material-ui/core/List';

import { Lines } from '@components';
import { Flex, MUI, Typography } from '@styles';

const Sidebar = (props) => {
  return (
    <>
      <Styled.Drawer open={props.open} onClose={() => props.onSidebarToggle()}>
        <Styled.Box>
          <Styled.List>
            <Styled.MenuHeader>
              <Styled.HeaderRow justifyContent="center">
                <Styled.AppIcon src={props.appIcon} />
                <Styled.AppName>{props.appName}</Styled.AppName>
              </Styled.HeaderRow>
            </Styled.MenuHeader>
            <MUI.Divider />
            {/* Menú Sidebar - Personalizado */}
            {props.sidebarChildren ? (
              props.sidebarChildren
            ) : (
              <>
                {/* Menú Sidebar */}
                {props.sidebarActions.map((action, index) => (
                  <MUI.MenuItem
                    button
                    key={index}
                    onClick={() => props.history.push(action.route)}
                  >
                    <Typography.Text>{action.label}</Typography.Text>
                  </MUI.MenuItem>
                ))}
              </>
            )}
          </Styled.List>
          <Lines
            direction="vertical"
            firstLine={{ size: 50, color: 'purple' }}
            secondLine={{ size: 50, color: 'blueDark' }}
          />
        </Styled.Box>
      </Styled.Drawer>
    </>
  );
};

Sidebar.propTypes = {
  // Boolean que indica si esta abierto el menú lateral.
  open: PropTypes.bool.isRequired,
  // History router.
  history: PropTypes.object,
  // El nombre de aplicación en la que se encuentra.
  appName: PropTypes.string,
  // Icono de aplicación en la que se encuentra.
  appIcon: PropTypes.string,
  // Array de acciones del menú lateral.
  sidebarActions: PropTypes.array,
  // Componente de React dentro del Drawer.
  sidebarChildren: PropTypes.node,
  // Función para desplegar el menú lateral.
  onSidebarToggle: PropTypes.func
};

// *************************************
// STYLED COMPONENTS                               
// *************************************

const Styled = {};

Styled.Drawer = styled(MuiDrawer)`
  .MuiDrawer-paperAnchorLeft {
    top: 64px;
  }

  .MuiBackdrop-root {
    top: 64px;
  }

  &.MuiDrawer-root {
    top: 64px !important;
    width: 250px;
  }
`;

Styled.Box = styled.div`
  display: flex;
  width: 100%;
  height: 100%;
  background-color: ${(props) => props.theme.colors.white};
`;

Styled.MenuHeader = styled(MUI.MenuHeader)`
  &.MuiListSubheader-root {
    height: 50px;
    min-width: 320px;
    border-bottom: none;
    background-color: ${(props) => props.theme.colors.greyHover};
  }
`;

Styled.AppIcon = styled.img`
  width: 24px;
  height: 24px;
  min-width: 24px;
  min-height: 24px;
  object-fit: contain;
`;

Styled.AppName = styled(Typography.Text)`
  font-family: 'Bryant Pro Medium';
  font-variant: small-caps;
  margin: 0 8px;
`;

Styled.HeaderRow = styled(Flex.Row)`
  height: 50px;
`;

Styled.List = styled(MuiList)`
  &.MuiList-root {
    padding: 0px;
  }    
`;

export default Sidebar;
